// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8641fca0","324":"a1b66b7f","453":"0bfc24fd","974":"e8fa3b88","996":"fa5e54f6"}[chunkId] + ".chunk.js";
};